(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_6db1c78"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('premium-value-banner')) {
    customElements.define('premium-value-banner', class extends HTMLElement {
      connectedCallback() {
        this.connectFrame = requestAnimationFrame(() => this.initialize());
      }

      initialize() {
        if (!this.isConnected) return;
        this.viewport = this.querySelector('.pvb__viewport');
        if (!this.viewport) return;
        this.track = this.querySelector('.pvb__track');
        this.group = this.querySelector('[data-original]');
        this.button = this.querySelector('.pvb__toggle');
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = Boolean(window.Shopify?.designMode);
        this.hovered = false;
        this.manual = false;
        this.visible = true;
        this.button.addEventListener('click', () => {
          this.paused = !this.paused;
          this.sync();
        }, options);
        this.viewport.addEventListener('pointerenter', (event) => {
          if (event.pointerType === 'mouse' && this.dataset.hover === 'true') {
            this.hovered = true;
            this.sync();
          }
        }, options);
        this.viewport.addEventListener('pointerleave', () => {
          this.hovered = false;
          this.sync();
        }, options);
        this.viewport.addEventListener('pointerdown', (event) => {
          if (event.pointerType !== 'mouse') {
            this.paused = true;
            this.sync();
          }
        }, options);
        this.viewport.addEventListener('focus', () => {
          this.manual = true;
          this.build();
        }, options);
        this.viewport.addEventListener('blur', () => {
          this.manual = false;
          this.build();
        }, options);
        this.motion.addEventListener('change', () => this.build(), options);
        document.addEventListener('visibilitychange', () => this.sync(), options);
        this.resizeObserver = new ResizeObserver(() => this.build());
        this.resizeObserver.observe(this.viewport);
        this.resizeObserver.observe(this.group);
        this.intersectionObserver = new IntersectionObserver(([entry]) => {
          this.visible = entry.isIntersecting;
          this.sync();
        });
        this.intersectionObserver.observe(this);
        this.build();
      }

      build() {
        const duration = Math.max(10, Number(this.dataset.duration) || 30) * 1000;
        const progress = this.animation ? (Number(this.animation.currentTime) || 0) % duration / duration : 0;
        this.animation?.cancel();
        this.animation = null;
        this.track.querySelectorAll('[data-copy]').forEach((copy) => copy.remove());
        const animate = !this.motion.matches && !this.manual;
        this.classList.toggle('is-animated', animate);
        this.button.hidden = this.motion.matches;
        if (!animate) {
          this.sync();
          return;
        }
        this.viewport.scrollLeft = 0;
        const distance = this.group.getBoundingClientRect().width;
        if (distance <= 0) return;
        const copies = Math.ceil(this.viewport.clientWidth / distance) + 1;
        for (let index = 0; index < copies; index++) {
          const copy = this.group.cloneNode(true);
          copy.removeAttribute('data-original');
          copy.setAttribute('data-copy', '');
          copy.setAttribute('aria-hidden', 'true');
          this.track.append(copy);
        }
        this.animation = this.track.animate([
          { transform: `translate3d(${-distance}px, 0, 0)` },
          { transform: 'translate3d(0, 0, 0)' }
        ], { duration, iterations: Infinity, easing: 'linear' });
        this.animation.currentTime = progress * duration;
        this.sync();
      }

      sync() {
        this.classList.toggle('is-paused', this.paused);
        const label = this.paused ? this.button.dataset.playLabel : this.button.dataset.pauseLabel;
        this.button.setAttribute('aria-label', label);
        this.button.setAttribute('title', label);
        if (!this.animation) return;
        if (this.paused || this.hovered || !this.visible || document.hidden) this.animation.pause();
        else this.animation.play();
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.connectFrame);
        this.animation?.cancel();
        this.controller?.abort();
        this.resizeObserver?.disconnect();
        this.intersectionObserver?.disconnect();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
